import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useSubmitLoginFormMutation } from "../../Services/LoginAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import "./style.css";
import { useGetFooterContentQuery } from "../../Services/SettingsAPI";
import CryptoJS from "crypto-js";

const Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false); // State for toggling password visibility
  const [errors, setErrors] = useState({ email: "", password: "", apiError: "" });
  const { data } = useGetFooterContentQuery();
  const [loginUser, { isLoading }] = useSubmitLoginFormMutation(); // RTK Query mutation
  const [APIerror, setApiError] = useState("")
  // Email validation regex
  const isValidEmail = (email) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);

  const encryptData = (data) => {
    const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
    const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

    if (!key || !iv) {
      console.error("Encryption key or IV is missing!");
      return null;
    }

    const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });

    return encrypted.toString();
  };

  // const decryptData = (encryptedData) => {
  //   try {
  //     const key = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_KEY);
  //     const iv = CryptoJS.enc.Hex.parse(process.env.REACT_APP_CRYPTOJS_AES_IV);

  //     if (!key || !iv) {
  //       console.error("Decryption key or IV is missing!");
  //       return null;
  //     }

  //     const decrypted = CryptoJS.AES.decrypt(encryptedData, key, {
  //       iv: iv,
  //       mode: CryptoJS.mode.CBC,
  //       padding: CryptoJS.pad.Pkcs7,
  //     });

  //     return JSON.parse(decrypted.toString(CryptoJS.enc.Utf8)); // Parse JSON if necessary
  //   } catch (error) {
  //     console.error("Error decrypting data:", error);
  //     return null;
  //   }
  // };



  const handleSubmit = async (e) => {
    e.preventDefault();
    let newErrors = { email: "", password: "", apiError: "" };
    

    // Validate email
    if (!email.trim()) {
      newErrors.email = "Email is required.";
    } else if (!isValidEmail(email)) {
      newErrors.email = "Enter a valid email address.";
    }

    // Validate password
    if (!password.trim()) {
      newErrors.password = "Password is required.";
    } else if (password.length < 6) {
      newErrors.password = "Password must be at least 6 characters.";
    }

    setErrors(newErrors);

    // Stop submission if errors exist
    if (newErrors.email || newErrors.password) return;

    try {

      const EncryptedUserName = encryptData(email);
      const EncryptedPassword = encryptData(password);

      const encryptedData = {
        email:EncryptedUserName,
        password:EncryptedPassword
      }

      const response = await loginUser(encryptedData).unwrap();
      localStorage.setItem("accessToken", response.access_token);
      localStorage.setItem("refreshToken", response.refresh_token);
      navigate("/");
    } catch (err) {
      console.error("Login failed:", err?.data?.error);
      setApiError(err?.data?.error || err?.data?.message)
      setErrors((prev) => ({
        ...prev,
        apiError: err.data?.error || "Invalid login credentials.",
      }));
    }
  };

      useEffect(() => {
          if (data?.data?.length > 0) {
              localStorage.setItem("Appname", data?.data[0]?.copyright_app_name);
              localStorage.setItem("favIcon", data?.data[0]?.fav_icon_path);

          }
      }, [data]);

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="text-center mb-4">Login</h2>
        <form onSubmit={handleSubmit}>
          {/* Email Field */}
          <div className="mb-3 text-start">
            <label htmlFor="email" className="form-label">Email</label>
            <input
              type="email"
              className={`form-control ${errors.email ? "is-invalid" : ""}`}
              id="email"
              placeholder="Enter your email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
            />
            {errors.email && <div className="invalid-feedback">{errors.email}</div>}
          </div>

          {/* Password Field with Toggle */}
          <div className="mb-3 text-start position-relative">
            <label htmlFor="password" className="form-label">Password</label>
            <div className="input-group">
              <input
                type={showPassword ? "text" : "password"}
                className={`form-control ${errors.password || errors.apiError ? "is-invalid" : ""}`}
                id="password"
                placeholder="Enter your password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
              />

              <FontAwesomeIcon className="password-show-hide" icon={showPassword ? faEyeSlash : faEye} onClick={() => setShowPassword(!showPassword)} />

            </div>
            <Link to="/forgot-password"><p className="forgot-password-text">Forgot Password</p></Link>
            {errors.password && <div className="invalid-feedback">{errors.password}</div>}
            {/* {APIerror && <div className="invalid-feedback">{APIerror}</div>} */}
          </div>

          <button type="submit" className="btn btn-primary w-100" disabled={isLoading}>
            {isLoading ? "Logging in..." : "Login"}
          </button>
          <div className="login-api-error">{APIerror}</div>
        </form>
      </div>
    </div>
  );
};

export default Login;
